import fetchClient from "@/utils/fetchClient"

/* eslint-disable */

export default {
  state: {
    activeAlarms: [],
    groupAlarms: [],
    eventHistory: [],

    loadingAlarms: false,
    loadingEventHistory: false
  },
  mutations: {
    setActiveAlarms(state, payload) {
      state.activeAlarms = payload
    },
    setGroupAlarms(state, payload) {
      state.groupAlarms = payload
    },
    setEventHistory(state, payload) {
      state.eventHistory = payload
    },
    setLoadingAlarms(state, payload) {
      state.loadingAlarms = payload
    },
    setLoadingEventHistory(state, payload) {
      state.loadingEventHistory = payload
    }
  },
  actions: {
    async fetchActiveAlarms(context, params) {
      return new Promise((resolve, reject) => {
        context.commit("setLoadingAlarms", true)

        let url = `/api/v1/tenants/${params.tenantUid}/machines/${params.serialNo}/events?q=active`

        fetchClient()
          .get(url)
          .then(data => {
            context.commit("setActiveAlarms", data)
            resolve()
          })
          .catch(error => {
            context.commit("setError", error)
            reject(error)
          })
          .finally(() => {
            context.commit("setLoadingAlarms", false)
          })
      })
    },
    async fetchGroupAlarms(context, params) {
      return new Promise((resolve, reject) => {
        context.commit("setLoadingAlarms", true)

        let url = `/api/v1/tenants/${params.tenantUid}/machines/${params.serialNo}/group_alarms`

        fetchClient()
          .get(url)
          .then(data => {
            context.commit("setGroupAlarms", data.alarms)
            resolve()
          })
          .catch(error => {
            context.commit("setError", error)
            reject(error)
          })
          .finally(() => {
            context.commit("setLoadingAlarms", false)
          })
      })
    },
    async fetchEventHistory(context, params) {
      return new Promise((resolve, reject) => {
        context.commit("setLoadingEventHistory", true)

        const { tenantUid, serialNo, start, end } = params

        fetchClient()
          .get(
            `/api/v1/tenants/${tenantUid}/machines/${serialNo}/events?q=range&start=${start}&end=${end}`
          )
          .then(data => {
            context.commit("setEventHistory", data)
            resolve()
          })
          .catch(error => {
            context.commit("setError", error)
            reject(error)
          })
          .finally(() => {
            context.commit("setLoadingEventHistory", false)
          })
      })
    }
  },
  getters: {
    activeAlarms(state) {
      return state.activeAlarms
    },
    groupAlarms(state) {
      return state.groupAlarms
    },
    eventHistory(state) {
      return state.eventHistory
    },
    loadingAlarms(state) {
      return state.loadingAlarms
    },
    loadingEventHistory(state) {
      return state.loadingEventHistory
    }
  }
}
